import { render, staticRenderFns } from "./FileSearchCard.vue?vue&type=template&id=fb1c4c3c&scoped=true&"
import script from "./FileSearchCard.vue?vue&type=script&lang=js&"
export * from "./FileSearchCard.vue?vue&type=script&lang=js&"
import style0 from "./FileSearchCard.vue?vue&type=style&index=0&id=fb1c4c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1c4c3c",
  null
  
)

export default component.exports